import Pusher from 'pusher-js';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { PUBLIC_LIVE_PAGE } from '../../../constants/app';
import { environment } from '../../../environments/environment';
import { pageState } from '../../../storage/app';
import { updatedCurrentStateState } from '../../../storage/client';
import { CurrentState } from '../../../types/currentState';

function PublicPusherProvider() {
  const page = useRecoilValue(pageState);
  const pusherRef = useRef<Pusher | null>(null);
  const setUpdatedCurrentState = useSetRecoilState(updatedCurrentStateState);
  const { shareLinkId } = useParams();

  useEffect(() => {
    if (!pusherRef.current) {
      pusherRef.current = new Pusher(environment.pusherKey ?? '', {
        cluster: environment.pusherCluster,
      });
    }

    return () => {
      pusherRef.current?.disconnect();
      pusherRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!shareLinkId || page !== PUBLIC_LIVE_PAGE.id) return;
    const pusher = pusherRef.current;
    if (!pusher) return;
    // TODO: uncomment when tracking page is available to public
    // if (page === TRACKING_PAGE.id && !assetId) return;
    // if (page === TRACKING_PAGE.id && assetId) {
    //   const liveKey = `live_${assetId}_${account.pusherKey}`;
    //   const channel = pusher.subscribe(liveKey);
    //   channel.bind('newPosition', (data: CurrentState) => {
    //     if (data && data.ident) {
    //       setUpdatedCurrentState(data);
    //     }
    //   });
    //   return () => {
    //     pusher.unsubscribe(liveKey);
    //   };
    // } else
    if (page === PUBLIC_LIVE_PAGE.id) {
      const mapKey = `map_${shareLinkId}`;
      const channel = pusher.subscribe(mapKey);
      channel.bind('newPosition', (data: CurrentState) => {
        if (data?.ident) {
          setUpdatedCurrentState(data);
        }
      });
      return () => {
        pusher.unsubscribe(mapKey);
      };
    }
  }, [shareLinkId, page]);

  return null;
}

export default PublicPusherProvider;
